module.exports = {"pageTitleText":"系統日誌","message":"內容","level":"等級","category":"類型","timestamp":"時間"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/systemLog.json
// module id = 7dSm
// module chunks = 3